<template>
    <div v-if="stations" class="station-list">
        <div class="inner">
            <h2 v-if="title" class="h3">{{ title }}</h2>
            <div class="stations">
                <div
                    v-for="station in stations"
                    :key="station.id"
                    class="station"
                >
                    <img v-if="station?.type.some(s => s.name === 'shell')" src="/images/shell-logo.png" />
                    <img v-else-if="station?.type.some(s => s.name === 'st1')" src="/images/st1-logo.webp" />
                    <template v-for="(link, key) in station?.links" :key="`${station.id}-link-${key}`">
                        <nuxt-link
                            class="link"
                            :to="link.to"
                            external
                        >
                            <span class="title">{{ station.title }}</span>
                        </nuxt-link>
                        {{ link.title }}
                        <DSIcon code="default-line/chevron-right" size="l" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'StationsList',
    props: {
        type: {
            type: String,
            required: false,
            default: 'list',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        stations: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
};
</script>
<style scoped>
.station-list {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.station-list .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}
.station-list {
  background: var(--color-secondary-500);
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.station-list:not(:last-child) {
  margin-bottom: 2rem;
}
.station-list .inner {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 0 2rem;
}
.station-list .inner .stations:first-child {
  grid-column-end: span 2;
  max-width: 720px;
  justify-self: center;
}
.station-list .inner .station {
  display: grid;
  grid-template-columns: 40px 2fr 1fr 1rem;
  border: 1px solid var(--color-base-grey-200);
  background: var(--color-base-white);
  align-items: center;
  min-height: 4.875rem;
  padding: 1.25rem 2rem;
  grid-gap: 0 2rem;
}
.station-list .inner .station .title {
  font-weight: 700;
}
.station-list .inner .station .link {
  justify-content: space-between;
  text-decoration: none;
  text-align: left;
}
.station-list .inner .station:not(:last-child) {
  margin-bottom: 0.375rem;
}
@media (max-width: 991px) {
  .station-list .inner {
    grid-template-columns: auto;
  }
  .station-list .inner .station {
    padding: 1rem;
    grid-gap: 0 1rem;
  }
}
</style>
